import * as React from 'react';
/* import { debug } from '../../../utils';
 * const log = debug('lego:About.tsx');*/
const S = require('./About.less') as any;

const R2D2_Logo = require('../../../assets/r2d2-logo.png') as any;
const CHS_Logo = require('../../../assets/chs-logo.png') as any;
const NIDILRR_Logo = require('../../../assets/nidilrr-logo.png') as any;
const NIDRR_Logo = require('../../../assets/nidrr-logo.png') as any;

export default class About extends React.Component< any,any> {
		render() {
				return (
					<div className={S.About}>
            <div>
								<h1>About</h1>
								<p>The AR-B app was created through funding from the National Institute on Disability & Rehabilitation Research (NIDRR) grant #H133G100211. The app was designed and created at the Rehabilitation Research Design & Disability <R2D2 /> Center located on the University of Wisconsin-Milwaukee campus.</p>
								<p>AccessPlace is a web application designed for users with disabilities and impairments to better navigate about the community. The application allows the user to communicate and obtain Personalized Accessibility Information (PAI) tailored to the individual’s functional impairments. The user creates a profile (Functional Impairment Profile) that allows the system to personalize the display of building information that is most relevant to their specific accessibility needs. The user may also view information provided by other people with disabilities and building visitors concerning the accessibility of various businesses. Reviews written by users with comparable profiles are sorted toward the top of the search list, and their ratings are given greater weight in correspondence to their level of similarity. This allows users to better prepare for environmental challenges they may face in a particular setting.</p>
								<p>The <R2D2 /> Center is dedicated to making the world more accessible for all people, including those with disabilities and impairments. Please use the app responsibly to ensure the best experience for everyone. Thank you for using our app!</p>
            </div>
						<div className={S.Logos}>
							<a href='http://www.r2d2.uwm.edu/'><img src={R2D2_Logo} alt='R2D2 Logo' className={S.logo} /></a>
							<a href='http://uwm.edu/healthsciences/'><img src={CHS_Logo} alt='CHS Logo' className={S.logo} /></a>
							<a href='http://www.acl.gov/programs/NIDILRR'><img src={NIDRR_Logo} alt='NIDRR Logo' className={S.logo} /></a>
							<a href='http://www.acl.gov/programs/NIDILRR'><img src={NIDILRR_Logo} alt='NIDILRR Logo' className={S.logo} /></a>
            </div>
					</div>
				);
		}
}

const R2D2 = () => (<span className='r2d2'>R<sub>2</sub>D<sub>2</sub></span>);



// WEBPACK FOOTER //
// ./src/app/containers/About/About.tsx